import Axios from 'axios'

const biFinancialAnalysis = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BASE_URL_API + '/dashboard/bi/v1'
    return AxiosInstance
  },

  getFinancialAnalysis(period) {
    return this.axios().get('/analise-financeira', {
      params: { periodo: period },
    })
  },
}

export default biFinancialAnalysis
